import JavascriptIcon from "@mui/icons-material/Javascript";
import LockOpenIcon from "@mui/icons-material/LockOpen";
export const mainMenuProvider = [
  {
    icon: LockOpenIcon,
    text: "Parse Payload",
    path: "/parse-payload",
  },
  {
    icon: JavascriptIcon,
    text: "Deobfuscate Script",
    path: "/deobfuscate-script",
  },
];
